import React from "react"

import LinkedAccountsTable from "./components/tables/LinkedAccountsTable";

export default class LinkedAccounts extends React.Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <>
        <LinkedAccountsTable
          title={'Linked Accounts'}
        />
      </>
    )
  }

}
